import { $Q, $Qll } from "../utils/query-selector"
import { toggleDataActive } from "../utils/toggle-dataset";

const handleDetailsClick = (index) => {
  $Q('.customer__wrapper').classList.add('hidden');

  const orderParent = $Q(`.customer__order:nth-of-type(${index + 1})`);
  orderParent.classList.remove('hidden');
}

const readDetailsClick = () => {
  $Qll('.customer__details').forEach((button, index) => {
    const buttonRef = button;
    buttonRef.addEventListener('click', () => handleDetailsClick(index))
  })
}

const readReturnClick = () => {
  $Qll('.customer__return').forEach((button) => {
    button.addEventListener('click', () => {
      const buttonRef = button;
      const parentOrder = buttonRef.closest('.customer__order');

      parentOrder.classList.add('hidden');
      $Q('.customer__wrapper').classList.remove('hidden');
    })
  })
}

const showPopup = () => {
  if (window.location.pathname.includes('account')) {
    toggleDataActive(
      '#calendly-button-js',
      '#calendly-modal-js',
      { overlay: true, closeSelector: '#calendly-close-btn-js', blockScroll: true }
    );
  }
}

export const initCustomerOrder = () => {
  readDetailsClick();
  readReturnClick();
  showPopup();
}
